"use strict";
'use es6';
/* eslint react/no-multi-comp: [1, {"ignoreStateless": true}] */

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _reactRouter = require("react-router");

var _SettingsApplication = _interopRequireDefault(require("./containers/SettingsApplication"));

// Only import and use "containers" for your route handlers
var getFirstVisibleModulePath = function getFirstVisibleModulePath(module, _ref) {
  var scopes = _ref.scopes,
      gates = _ref.gates;

  if (module.modules) {
    var foundModule = module.modules.find(function (nestedModule) {
      return nestedModule.shouldModuleRender({
        scopes: scopes,
        gates: gates
      });
    });

    if (foundModule && foundModule.modules) {
      return foundModule.route + "/" + getFirstVisibleModulePath(foundModule, {
        scopes: scopes,
        gates: gates
      });
    } else if (foundModule) {
      return foundModule.route;
    }

    return null;
  }

  return module.route;
};

var generateNestedRouteFromModule = function generateNestedRouteFromModule(module, _ref2) {
  var scopes = _ref2.scopes,
      gates = _ref2.gates;

  if (module.shouldModuleRender({
    scopes: scopes,
    gates: gates
  })) {
    if (module.modules) {
      return _react.default.createElement(_reactRouter.Route, {
        path: module.route,
        key: module.route
      }, _react.default.createElement(_reactRouter.IndexRedirect, {
        to: getFirstVisibleModulePath(module, {
          scopes: scopes,
          gates: gates
        })
      }), module.modules.map(function (nested) {
        return generateNestedRouteFromModule(nested, {
          scopes: scopes,
          gates: gates
        });
      }));
    }

    if (module.routes.key) {
      return module.routes;
    }

    var resolvedRoutes = typeof module.routes === 'function' ? module.routes({
      scopes: scopes,
      gates: gates
    }) : module.routes;
    return _react.default.cloneElement(resolvedRoutes, {
      key: module.route
    });
  }

  return null;
};

var createRoutes = function createRoutes(_ref3) {
  var rootModule = _ref3.rootModule,
      scopes = _ref3.scopes,
      gates = _ref3.gates;
  return _react.default.createElement(_reactRouter.Route, {
    path: "/",
    component: _SettingsApplication.default
  }, _react.default.createElement(_reactRouter.IndexRedirect, {
    to: getFirstVisibleModulePath(rootModule, {
      scopes: scopes,
      gates: gates
    })
  }), rootModule.modules.map(function (nested) {
    return generateNestedRouteFromModule(nested, {
      scopes: scopes,
      gates: gates
    });
  }), _react.default.createElement(_reactRouter.Redirect, {
    from: "*",
    to: "/"
  }));
};

createRoutes.propTypes = {
  rootModule: _propTypes.default.object,
  scopes: _propTypes.default.array,
  gates: _propTypes.default.array
};
var _default = createRoutes;
exports.default = _default;
module.exports = exports.default;